<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh">
            <Col :xs="24" :md="20">
                <Card class="shadow">
                    <h1 class="text-center text-20 text-primary">{{ $t("views.register.title") }}</h1>
                    <Alert v-if="data.errorMessage" type="error" :message="data.errorMessage" show-icon
                           class="mb-3"></Alert>
                    <div class="mb-4">
                        <Steps :current="data.indexPage" size="small">
                            <Step :title="$t('views.register.title')"></Step>
                            <Step :title="$t('views.company.address.title')"></Step>
                            <Step :title="$t('views.company.register.attachment.title')"></Step>
                            <Step :title="$t('model.user.modelName')"></Step>
                        </Steps>
                    </div>
                    <Form :ref="(e) => (refs.form = e)" layout="horizontal">
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm"
                                         :fields="data.fields"></TemplateBuilder>
                    </Form>

                    <div class="d-flex">
                        <div class="text-left">
                            <Button class="ml-auto px-3 btn-primary" @click="() => onClickPrePage(data)"
                                    v-if="data.indexPage > 0">
                                <span>{{ $t("button.back") }}</span>
                            </Button>
                        </div>
                        <Button class="ml-auto px-3 btn-primary" @click="() => onClickRegister({ data })"
                                :disabled="isLoading" v-if="data.indexPage == 3">
                            <CIcon file="login.svg"></CIcon>
                            <span>{{ $t("button.register") }}</span>
                        </Button>
                        <Button class="ml-auto px-3 btn-primary" @click="() => onClickNextPage({ data })"
                                v-if="data.indexPage < 3">
                            <span>{{ $t("button.ok") }}</span>
                        </Button>
                    </div>
                    <div class="text-right">
                        <router-link :to="{ name: 'login' }"> {{ $t("button.login") }} ?</router-link>
                    </div>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
    import { Alert, Form, Button, Row, Col, Card, Layout, Steps } from "ant-design-vue";
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { initForm, isLoading, onClickNextPage, onClickPrePage, onClickRegister } from "./register.logic";

    export default defineComponent({
        components: {
            TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
            Form,
            Button,
            Alert,
            Row,
            Col,
            Card,
            Layout,
            Steps,
            Step: Steps.Step,
            CIcon: defineAsyncComponent(() => import("../../../components/icon/CIcon"))
        },
        setup(props) {
            const data = reactive({
                rowProp: { gutter: 24 },
                errorMessage: null,
                section: {},
                changeLogFields: [],
                indexPage: 0
            });
            const refs = reactive({ form: null });
            initForm({ props, data, refs });
            return { props, data, refs, isLoading, onClickRegister, onClickNextPage, onClickPrePage };
        }
    });
</script>


<style scoped>
    .bg-account {
        background-image: url("../../../assets/bg/bg-account.jpg");
        background-size: 100% 100%;
    }
</style>